const { createContext } = require("react");

const CheckUserLoggedInContext = createContext(null);

export default CheckUserLoggedInContext;
